import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Shape from '../../../components/utils/shape';
import { colors } from '../../../styles';
import { useCustomizer } from './context';

const VictoryBar = () => {
  const { actions } = useCustomizer();
  const [selected, setSelected] = useState(true);

  useEffect(() => {
    actions.updateSlice('win', selected);
  }, [selected]);

  return (
    <>
      <div className="row-center align-center">
        <motion.div
          onClick={() => setSelected(false)}
          whileTap={{ scale: 1.1 }}
          whileHover={{ scale: 1.1 }}
          className=" txt-pointer shape-container"
        >
          <Shape.Triangle
            fill={!selected ? colors.accent : colors.ultrapurple}
            size={90}
            transform={'rotate(180deg) translateY(19px)'}
          />
        </motion.div>
        <motion.div
          className="txt-pointer shape-container"
          whileTap={{ scale: 1.1 }}
          whileHover={{ scale: 1.1 }}
          onClick={() => setSelected(true)}
        >
          <Shape.Triangle
            fill={selected ? colors.accent : colors.ultrapurple}
            size={90}
          />
        </motion.div>
      </div>
      <p className="txt-uppercase -accent txt-s txt-left">
        {selected ? 'Victoria' : 'Derrota'}
      </p>
    </>
  );
};

export default VictoryBar;
